/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommentItem } from '../../models/comment-item';

export interface CommentControllerCreateInactive$Params {
  monitoringId: number;
}

export function commentControllerCreateInactive(http: HttpClient, rootUrl: string, params: CommentControllerCreateInactive$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>> {
  const rb = new RequestBuilder(rootUrl, commentControllerCreateInactive.PATH, 'post');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommentItem;
      }>;
    })
  );
}

commentControllerCreateInactive.PATH = '/monitoring/{monitoringId}/comments/create-inactive';
